import { cn } from "@humanex/ui/libs";
import * as React from "react";

export * from "./select";
export * from "./quantity-input";
export * from "./textarea";
// export * from "./ckeditor";
export * from "./image-input";
export * from "./Tiptap";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  labelClassName?: string;
  error?: string;
  containerClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, labelClassName, required, error, containerClassName, ...props }, ref) => {
    return (
      <div className={cn(containerClassName)}>
        {label && (
          <div className={cn("text-responsive-base font-medium text-slate-400 mb-1", labelClassName)}>
            {label} {required && <span className="text-error-500">(*)</span>}
          </div>
        )}
        <input
          type={type}
          required={required}
          className={cn(
            "h-10 w-full rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-normal text-ink",
            "placeholder:text-gray-500",
            "focus:outline-none focus:ring-none",
            "disabled:opacity-40",
            error && "border-error-500",
            className
          )}
          ref={ref}
          {...props}
        />
        {error && <p className="text-xs text-error-500 mt-1">{error}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";
